var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showModalVisualizaPdf
        ? _c("visualizar-documentos", {
            attrs: { documentos: _vm.documentoSelecionado },
            on: { closeModal: _vm.closeModalVisualizaPdf }
          })
        : _vm._e(),
      _vm.visualizarlabelTitulo
        ? _c(
            "div",
            [
              _vm.showDivider
                ? _c("app-divider", {
                    attrs: { label: _vm.titulo, tooltip: _vm.informacao }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-row",
        [
          _c("app-upload-documentos", {
            attrs: {
              id: _vm.idUploadDocumento,
              target: _vm.urlUpload,
              fileType: _vm.validExtensions,
              tiposDocumentos: _vm.documentosFiltrados,
              pecasTecnicas: _vm.pecasTecnicas,
              maxSize: _vm.maxSize,
              aba: _vm.aba,
              required:
                _vm.tiposDocumentosObrigatorios &&
                _vm.tiposDocumentosObrigatorios.length > 0 &&
                _vm.isRequired,
              documentos: _vm.documentos,
              mensagemErroFilaPlantaMemorial:
                _vm.mensagemErroFilaPlantaMemorial,
              isValidacaoPeloMenosUmDocumento:
                _vm.isValidacaoPeloMenosUmDocumento,
              mensagemOutros: _vm.mensagemOutros
            },
            on: {
              mudaTipo: _vm.mudaTipo,
              anexar: _vm.anexar,
              setDadosPlanilha: _vm.setDadosPlanilha
            },
            model: {
              value: _vm.documentoSelecionado,
              callback: function($$v) {
                _vm.documentoSelecionado = $$v
              },
              expression: "documentoSelecionado"
            }
          })
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("validation-provider", {
            attrs: {
              rules: _vm.requireDocumentosObrigatorios(),
              name: _vm.aba + "/Documentos"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var errors = ref.errors
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "input",
                        class: { "erro box-error": errors.length }
                      },
                      [
                        _c(
                          "el-table",
                          {
                            attrs: { data: _vm.documentos },
                            model: {
                              value: _vm.validationValues,
                              callback: function($$v) {
                                _vm.validationValues = $$v
                              },
                              expression: "validationValues"
                            }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "empty" }, slot: "empty" },
                              [
                                _c("span", [
                                  _vm._v(
                                    'Nenhum arquivo adicionado. Para adicionar um novo arquivo, selecione-o e clique no botão "Anexar".'
                                  )
                                ])
                              ]
                            ),
                            _c("el-table-column", {
                              attrs: {
                                prop: "tipoDocumento.descricao",
                                label: "Tipo de documento:",
                                align: "left"
                              }
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "fileName", label: "Anexos" }
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "Ações",
                                align: "center",
                                width: "100"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("app-action-button", {
                                          attrs: {
                                            disabled: !_vm.isDocumentoParaVisualizacao(
                                              scope.row
                                            ),
                                            cor: !_vm.isDocumentoParaVisualizacao(
                                              scope.row
                                            )
                                              ? "#C0C4CC"
                                              : "#666666",
                                            icone: "eye",
                                            text: !_vm.isDocumentoParaVisualizacao(
                                              scope.row
                                            )
                                              ? "Não é possível exibir esse arquivo"
                                              : "Visualizar",
                                            fontSize: "18"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.abrirDocumento(
                                                scope.row
                                              )
                                            }
                                          }
                                        }),
                                        scope.row.id
                                          ? _c("app-action-button", {
                                              attrs: {
                                                icone: "download",
                                                cor: "#666666",
                                                text: "Baixar Documento"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.getDownload(
                                                    scope.row
                                                  )
                                                }
                                              }
                                            })
                                          : _vm._e(),
                                        _c("app-action-button", {
                                          attrs: {
                                            icone: "times",
                                            cor: "#CF0021",
                                            text: "Remover documento"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteRow(
                                                scope.row,
                                                scope.$index
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("span", { staticClass: "help erro" }, [
                      _vm._v(_vm._s(errors[0]))
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fcaf6d80", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcaf6d80","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppDocumentos.vue
// module id = null
// module chunks = 